"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DefaultTransceiverController_1 = require("./DefaultTransceiverController");

var SimulcastTransceiverController = /*#__PURE__*/function (_DefaultTransceiverCo) {
  _inherits(SimulcastTransceiverController, _DefaultTransceiverCo);

  var _super = _createSuper(SimulcastTransceiverController);

  function SimulcastTransceiverController(logger, browserBehavior) {
    var _this;

    _classCallCheck(this, SimulcastTransceiverController);

    _this = _super.call(this, logger, browserBehavior);
    _this.videoQualityControlParameterMap = new Map();
    var scale = 4;

    for (var i = 0; i < SimulcastTransceiverController.NAME_ARR_ASCENDING.length; i++) {
      var ridName = SimulcastTransceiverController.NAME_ARR_ASCENDING[i];

      _this.videoQualityControlParameterMap.set(ridName, {
        rid: ridName,
        scaleResolutionDownBy: scale,
        maxBitrate: SimulcastTransceiverController.BITRATE_ARR_ASCENDING[i] * 1000
      });

      scale = scale / 2;
    }

    return _this;
  } // Note: `scaleResolutionDownBy` has only been tested with values 1, 2, and 4.


  _createClass(SimulcastTransceiverController, [{
    key: "setEncodingParameters",
    value: function setEncodingParameters(encodingParamMap) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var sender, newEncodingParams, oldParam, i;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!this._localCameraTransceiver || this._localCameraTransceiver.direction !== 'sendrecv')) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                sender = this._localCameraTransceiver.sender;
                newEncodingParams = Array.from(encodingParamMap.values());

                if (!(newEncodingParams.length <= 0)) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return");

              case 6:
                oldParam = sender.getParameters();

                if (!oldParam.encodings) {
                  oldParam.encodings = newEncodingParams;
                } else {
                  for (i = 0; i < oldParam.encodings.length; i++) {
                    if (oldParam.encodings[i].rid === SimulcastTransceiverController.LOW_LEVEL_NAME) {
                      oldParam.encodings[i].maxBitrate = encodingParamMap.get(SimulcastTransceiverController.LOW_LEVEL_NAME).maxBitrate;
                      oldParam.encodings[i].active = encodingParamMap.get(SimulcastTransceiverController.LOW_LEVEL_NAME).active;
                      oldParam.encodings[i].scaleResolutionDownBy = encodingParamMap.get(SimulcastTransceiverController.LOW_LEVEL_NAME).scaleResolutionDownBy;
                    }

                    if (oldParam.encodings[i].rid === SimulcastTransceiverController.MID_LEVEL_NAME) {
                      oldParam.encodings[i].maxBitrate = encodingParamMap.get(SimulcastTransceiverController.MID_LEVEL_NAME).maxBitrate;
                      oldParam.encodings[i].active = encodingParamMap.get(SimulcastTransceiverController.MID_LEVEL_NAME).active;
                      oldParam.encodings[i].scaleResolutionDownBy = encodingParamMap.get(SimulcastTransceiverController.MID_LEVEL_NAME).scaleResolutionDownBy;
                    }

                    if (oldParam.encodings[i].rid === SimulcastTransceiverController.HIGH_LEVEL_NAME) {
                      oldParam.encodings[i].maxBitrate = encodingParamMap.get(SimulcastTransceiverController.HIGH_LEVEL_NAME).maxBitrate;
                      oldParam.encodings[i].active = encodingParamMap.get(SimulcastTransceiverController.HIGH_LEVEL_NAME).active;
                      oldParam.encodings[i].scaleResolutionDownBy = encodingParamMap.get(SimulcastTransceiverController.HIGH_LEVEL_NAME).scaleResolutionDownBy;
                    }
                  }
                }

                _context.next = 10;
                return sender.setParameters(oldParam);

              case 10:
                this.logVideoTransceiverParameters();

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "setVideoSendingBitrateKbps",
    value: function setVideoSendingBitrateKbps(_bitrateKbps) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return");

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }
  }, {
    key: "setupLocalTransceivers",
    value: function setupLocalTransceivers() {
      if (!this.useTransceivers()) {
        return;
      }

      if (!this.defaultMediaStream && typeof MediaStream !== 'undefined') {
        this.defaultMediaStream = new MediaStream();
      }

      if (!this._localAudioTransceiver) {
        this._localAudioTransceiver = this.peer.addTransceiver('audio', {
          direction: 'inactive',
          streams: [this.defaultMediaStream]
        });
      }

      if (!this._localCameraTransceiver) {
        var encodingParams = Array.from(this.videoQualityControlParameterMap.values());
        this._localCameraTransceiver = this.peer.addTransceiver('video', {
          direction: 'inactive',
          streams: [this.defaultMediaStream],
          sendEncodings: encodingParams
        });
      }
    }
  }, {
    key: "logVideoTransceiverParameters",
    value: function logVideoTransceiverParameters() {
      var params = this._localCameraTransceiver.sender.getParameters();

      var encodings = params.encodings;
      var msg = 'simulcast: current encoding parameters \n';

      var _iterator = _createForOfIteratorHelper(encodings),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var encodingParam = _step.value;
          msg += "rid=".concat(encodingParam.rid, " maxBitrate=").concat(encodingParam.maxBitrate, " active=").concat(encodingParam.active, " scaleDownBy=").concat(encodingParam.scaleResolutionDownBy, " \n");
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.logger.info(msg);
    }
  }], [{
    key: "replaceAudioTrackForSender",
    value: function replaceAudioTrackForSender(sender, track) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (sender) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return", false);

              case 2:
                _context3.next = 4;
                return sender.replaceTrack(track);

              case 4:
                return _context3.abrupt("return", true);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
    }
  }]);

  return SimulcastTransceiverController;
}(DefaultTransceiverController_1.default);

exports.default = SimulcastTransceiverController;
SimulcastTransceiverController.LOW_LEVEL_NAME = 'low';
SimulcastTransceiverController.MID_LEVEL_NAME = 'mid';
SimulcastTransceiverController.HIGH_LEVEL_NAME = 'hi';
SimulcastTransceiverController.NAME_ARR_ASCENDING = ['low', 'mid', 'hi'];
SimulcastTransceiverController.BITRATE_ARR_ASCENDING = [200, 400, 1100];